import tulsi from '../../Data/bod/tulsi.png';

const members = [
    {
      name: 'Mr. Tulsi Kumar Singh',
      title: 'CEO',
      description: 'Tulsi Kumar Singh, the CEO of Ocimum Investment Pvt. Ltd., is a visionary leader with a deep understanding of the financial sector. With years of experience and a strong track record, he excels in driving strategic growth and fostering innovation. His commitment to sustainable investment practices ensures that OIPL remains at the forefront of impactful investing in Nepal.',
      image: tulsi
    },
    {
      name: 'Mr. Tulsi Kumar Singh',
      title: 'CEO',
      description: 'Tulsi Kumar Singh, the CEO of Ocimum Investment Pvt. Ltd., is a visionary leader with a deep understanding of the financial sector. With years of experience and a strong track record, he excels in driving strategic growth and fostering innovation. His commitment to sustainable investment practices ensures that OIPL remains at the forefront of impactful investing in Nepal.',
      image: tulsi
    },
    {
      name: 'Mr. Tulsi Kumar Singh',
      title: 'CEO',
      description: 'Tulsi Kumar Singh, the CEO of Ocimum Investment Pvt. Ltd., is a visionary leader with a deep understanding of the financial sector. With years of experience and a strong track record, he excels in driving strategic growth and fostering innovation. His commitment to sustainable investment practices ensures that OIPL remains at the forefront of impactful investing in Nepal.',
      image: tulsi
    },
    {
      name: 'Mr. Tulsi Kumar Singh',
      title: 'CEO',
      description: 'Tulsi Kumar Singh, the CEO of Ocimum Investment Pvt. Ltd., is a visionary leader with a deep understanding of the financial sector. With years of experience and a strong track record, he excels in driving strategic growth and fostering innovation. His commitment to sustainable investment practices ensures that OIPL remains at the forefront of impactful investing in Nepal.',
      image: tulsi
    },
    {
      name: 'Mr. Tulsi Kumar Singh',
      title: 'CEO',
      description: 'Tulsi Kumar Singh, the CEO of Ocimum Investment Pvt. Ltd., is a visionary leader with a deep understanding of the financial sector. With years of experience and a strong track record, he excels in driving strategic growth and fostering innovation. His commitment to sustainable investment practices ensures that OIPL remains at the forefront of impactful investing in Nepal.',
      image: tulsi
    },
  ];

  export default members;